import { useState } from 'react';
import { hotComments } from '@/mocks/comments';
import SectionHeading from './SectionHeading';

export default function CommentBuzz() {
  const [likedIds, setLikedIds] = useState<string[]>([]);
  const [draft, setDraft] = useState('');
  const [message, setMessage] = useState('');

  const toggleLike = (id: string) => {
    setLikedIds((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : prev.concat(id)));
  };

  const handlePublish = () => {
    if (!draft.trim()) {
      setMessage('写点看法再发布吧，比如你对这条线索的判断。');
      return;
    }
    setMessage('演示环境：评论已记录在本地，未接入真实发布接口。');
  };

  return (
    <section id="hudong" className="bg-background-100 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          index="04"
          title="吃瓜互动 · 热评现场"
          subtitle="每条线索都有人在下面讨论，点赞与回复构成了这里的氛围"
          accent="primary"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 space-y-4">
            {hotComments.map((comment) => {
              const liked = likedIds.includes(comment.id);
              return (
                <article key={comment.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-heading font-bold shrink-0">
                      {comment.initial}
                    </span>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-medium text-foreground-900">{comment.name}</span>
                        <span className="px-1.5 py-0.5 rounded text-[11px] bg-accent-100 text-accent-700">{comment.tag}</span>
                        <span className="text-xs text-foreground-400">{comment.time}</span>
                      </div>
                      <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
                      <div className="mt-3 flex items-center gap-4 text-xs">
                        <button
                          type="button"
                          onClick={() => toggleLike(comment.id)}
                          className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                            liked ? 'text-primary-600 bg-primary-50' : 'text-foreground-500 hover:text-primary-600 hover:bg-background-100'
                          }`}
                        >
                          <i className={liked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}></i>
                          {comment.likes + (liked ? 1 : 0)}
                        </button>
                        <span className="inline-flex items-center gap-1.5 text-foreground-500">
                          <i className="ri-chat-3-line"></i>
                          {comment.replies} 条回复
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <aside className="lg:col-span-4 space-y-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
                <i className="ri-chat-smile-2-line text-primary-600"></i>
                说说你的看法
              </h3>
              <textarea
                value={draft}
                maxLength={500}
                onChange={(e) => setDraft(e.target.value)}
                rows={4}
                placeholder="理性吃瓜，尊重当事人隐私，避免人身攻击…"
                className="mt-3 w-full px-3 py-2 rounded-md border border-background-200 bg-background-100 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 resize-none"
              ></textarea>
              <div className="mt-2 flex items-center justify-between">
                <span className="text-xs text-foreground-400">{draft.length}/500</span>
                <button
                  type="button"
                  onClick={handlePublish}
                  className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  发布评论
                </button>
              </div>
              {message ? <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{message}</p> : null}
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
                <i className="ri-bar-chart-2-line text-accent-600"></i>
                互动氛围
              </h3>
              <ul className="mt-3 space-y-3">
                <li className="flex items-center justify-between text-sm">
                  <span className="text-foreground-600">今日评论总数</span>
                  <span className="font-heading font-bold text-foreground-950">3,412</span>
                </li>
                <li className="flex items-center justify-between text-sm">
                  <span className="text-foreground-600">参与讨论人数</span>
                  <span className="font-heading font-bold text-foreground-950">1,286</span>
                </li>
                <li className="flex items-center justify-between text-sm">
                  <span className="text-foreground-600">单条最高点赞</span>
                  <span className="font-heading font-bold text-foreground-950">1,284</span>
                </li>
              </ul>
              <div className="mt-4 h-2 rounded-full bg-background-200 overflow-hidden">
                <div className="h-full w-[72%] rounded-full bg-accent-500"></div>
              </div>
              <p className="mt-2 text-xs text-foreground-500">今日互动完成度 72%，讨论氛围持续升温。</p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}